import { render, staticRenderFns } from "./FranchisorContactListPagination.vue?vue&type=template&id=0b8c8782&scoped=true&"
import script from "./FranchisorContactListPagination.vue?vue&type=script&lang=js&"
export * from "./FranchisorContactListPagination.vue?vue&type=script&lang=js&"
import style0 from "./FranchisorContactListPagination.vue?vue&type=style&index=0&id=0b8c8782&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8c8782",
  null
  
)

export default component.exports